<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingAttributes"/>
    <input v-model="product.brand" class="form-input" slot="brands" :disabled="disabledInputs()">

    <form-group :label="$t('category.label')" :columns="4" :error="getError('category', product.productId)" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="value"
      />
    </form-group>

    <div class="l-col-12@md" v-if="attributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>
    <form-group v-for="(attribute, index) in attributes" :key="attribute.code" :label="attribute.name" :columns="3" :error="getError(attribute.code, product.productId)" :required="attribute.required">
      <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()">
    </form-group>

  </shared-product-provide>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import notifier from '@/notifier'
  import utils from 'utiljs-strings'
  import { AllHtmlEntities } from 'html-entities'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'colombo'
      },
      maxDescriptionLengthDI: 4000,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingAttributes: false,
      categories: [],
      attributes: [],
      category: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('brands', [
        'getBrands'
      ])
    },
    async mounted () {
      try {
        this.categories = await api.getCategories('marketplace', 'colombo')
      } catch (err) {
        notifier.error('Erro ao buscar categorias da Colombo.', 'Erro')
      }

      this.product.category = ''

      const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)
      if (presetCategorization !== null && presetCategorization !== undefined) {
        this.category = this.categories.find(category => category.value === presetCategorization.categories)
      }
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      ...mapActions('brands', [
        'fetchBrands'
      ]),
      formatProduct () {
        this.clearErrors()

        this.attributes
          .map(attribute => {
            if (attribute.value === undefined && attribute.required) {
              this.addError({
                productId: this.product.productId,
                property: attribute.code,
                error: {
                  message: 'required',
                  value: 1
                }
              })
            }
          })

        const attributes = this.attributes
          .filter(attribute => attribute.value !== undefined)
          .map(attribute => {
            return {
              id: attribute.attributeId,
              label: attribute.name,
              valueId: attribute.value !== undefined ? attribute.value : null,
              valueLabel: attribute.value !== undefined ? attribute.value : null
            }
          })

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            return {
              attributes: attributes,
              brand: this.product.brand,
              category: this.product.category.toString(),
              color: variation.attributes['color'],
              crossDocking: {
                quantity: variation.crossDocking || 1
              },
              description: this.product.description,
              ean: variation.ean,
              externalProductId: null,
              grid: this.getGrid(variation),
              gridType: this.getType(variation),
              height: variation.height,
              images: variation.images.length ? variation.images.map(image => ({
                picture: image
              })) : null,
              length: variation.length,
              original: {
                product: this.product,
                variation: variation
              },
              price: variation.price,
              productId: this.product.productId.toString(),
              sku: variation.sku,
              source: this.fromModule,
              stock: variation.stock,
              title: this.product.title,
              weight: variation.weight,
              width: variation.width
            }
          }
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      },
      getType (variation) {
        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return null
      },
      async getAttributes () {
        if (!this.product.category) {
          return false
        }
        this.loadingAttributes = true
        this.attributes = ''
        this.attributes = (await api.colombo.getAttributes(this.product.category)).map(attribute => {
          if (attribute.name === 'Garantia') {
            const attributeValue = utils.stripTags(AllHtmlEntities.decode(this.product.warranty), '')

            if (attributeValue) {
              attribute.value = attributeValue
            }

            return attribute
          }

          return attribute
        })

        this.loadingAttributes = false
      }
    },
    watch: {
      category (value) {
        this.product.category = value.value

        this.getAttributes()
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?dd9d6696